export default "__VITE_ASSET__09ebfeef__"